import React, { useState } from 'react';
import ngDateFilter from '../../ngDateFilter.js';
import { post } from '../../misc/qf.js';
import AvailabilityToggles from './AvailabilityToggles.jsx';

const AvailabilityDataHolder = ({
  availability,
  currentMember,
  childMembers,
  isRecurring,
  nextOccurrence,
  targetOccurrence,
  submitUrl,
}) => {
  const allMembers = [currentMember, ...childMembers];
  const [error, setError] = useState(null);
  const [availabilityByMemberId, setAvailabilityByMemberId] = useState(availability);
  async function onStatusChange(memberId, newStatus) {
    try {
      const params = {...availability[memberId]};
      params.team_member_id = memberId;
      params.status = newStatus;
      if (newStatus === 'available') {
        params.excused = false;
      }
      const res = await post(submitUrl, params);
      if (res.ok) {
        setAvailabilityByMemberId((prevState) => {
          return {
            ...prevState,
            [memberId]: {...prevState[memberId], status: newStatus},
          };
        });
      }
      setError(false);
    } catch (err) {
      console.error(err)
      setError(`Something went wrong. Please try again or reload the page`);
    }
  }
  let heading = (
    <h2 className="TeamAvailability">
      <p className="mb-1">Will you be attending?</p>
    </h2>
  );
  let subheading = null;
  if (isRecurring) {
    if (targetOccurrence && targetOccurrence != nextOccurrence) {
      if (targetOccurrence < nextOccurrence) {
        heading = (
          <h2 className="TeamAvailability">
            <p className="mb-1">Attendance Recorded</p>
          </h2>
        );
        subheading = (<h3 className="mt-1">Attendance: {ngDateFilter(targetOccurrence, 'mediumDate')}</h3>);
      } else {
        subheading = (<h3 className="mt-1">Upcoming: {ngDateFilter(targetOccurrence, 'mediumDate')}</h3>);
      }
    } else {
      subheading = (<h3 className="mt-1">Next: {ngDateFilter(nextOccurrence, 'mediumDate')}</h3>);
    }
  }
  return (
    <>
      {heading}
      <div className="shadow-sm pt-1">
        {subheading}
        {allMembers.map((member) => (
          <AvailabilityToggles
            key={member.id}
            member={member}
            data={availabilityByMemberId[member.id]}
            onChange={onStatusChange}
          />
        ))}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
      </div>
    </>
  );
};
export default AvailabilityDataHolder;
